export default __webpack_public_path__ + "static/media/puutarha_1.c0e6d85d.jpeg";